import { render } from "./ComponentesProjeto.vue?vue&type=template&id=28dc7dc8"
import script from "./ComponentesProjeto.vue?vue&type=script&lang=js"
export * from "./ComponentesProjeto.vue?vue&type=script&lang=js"

import "./ComponentesProjeto.vue?vue&type=style&index=0&id=28dc7dc8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__